(() => {
  class ProductStickyAtc extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.section-product-template');
      this.productArea = this.section?.querySelector('.product-area');
      this.trigger = this.section?.querySelector('.product-area__details product-form button[name="add"]') || this.productArea;
      if (!this.section || !this.productArea) return;

      this.handleVariantChange = (event) => {
        const selectedOptions = event.detail?.selectedOptions;
        if (!Array.isArray(selectedOptions)) return;

        window.requestAnimationFrame(() => this.syncVariantPickers(selectedOptions, event.detail?.variant));
      };
      this.handleStickyOptionChange = (event) => {
        const stickyPicker = event.target.closest('variant-picker');
        if (!stickyPicker || !this.contains(stickyPicker)) return;

        const selectedOptions = this.getSelectedOptions(stickyPicker);
        this.syncVariantPickers(selectedOptions);
      };

      this.section.addEventListener('on:variant:change', this.handleVariantChange);
      this.addEventListener('change', this.handleStickyOptionChange, true);

      this.observer = new IntersectionObserver(
        ([entry]) => {
          const scrolledPastTrigger = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          if (scrolledPastTrigger) {
            this.classList.remove('sticky-atc--hidden');
            this.classList.add('sticky-atc--active');
          } else {
            this.classList.add('sticky-atc--hidden');
            this.classList.remove('sticky-atc--active');
          }
        },
        { threshold: 0 }
      );

      this.observer.observe(this.trigger);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.section?.removeEventListener('on:variant:change', this.handleVariantChange);
      this.removeEventListener('change', this.handleStickyOptionChange, true);
    }

    getSelectedOptions(picker) {
      const selectedOptions = [];

      picker.querySelectorAll('.option-selector:not(.option-selector--custom)').forEach((selector) => {
        const optionIndex = Number(selector.dataset.index) - 1;
        if (selector.dataset.selectorType === 'dropdown') {
          selectedOptions[optionIndex] = selector.querySelector('.custom-select__option[aria-selected="true"]')?.dataset.value || null;
        } else {
          selectedOptions[optionIndex] = selector.querySelector('input.js-option:checked')?.value || null;
        }
      });

      return selectedOptions;
    }

    syncVariantPickers(selectedOptions, variant) {
      this.section.querySelectorAll('variant-picker').forEach((picker) => {
        picker.variant = variant || picker.variant;

        picker.querySelectorAll('.option-selector:not(.option-selector--custom)').forEach((selector) => {
          const optionIndex = Number(selector.dataset.index) - 1;
          const selectedValue = selectedOptions[optionIndex];
          if (selectedValue == null) return;

          if (selector.dataset.selectorType === 'dropdown') {
            this.syncDropdown(selector, selectedValue);
          } else {
            const inputs = selector.querySelectorAll('input.js-option');
            inputs.forEach((input) => {
              input.checked = input.value === selectedValue;
            });

            const selectedLabel = selector.querySelector('.option-selector__label-value');
            if (selectedLabel) selectedLabel.textContent = selectedValue;
          }
        });
      });
    }

    syncDropdown(selector, selectedValue) {
      const customSelect = selector.querySelector('custom-select');
      if (!customSelect) return;

      const options = customSelect.querySelectorAll('.custom-select__option');
      const selectedOption = Array.from(options).find((option) => option.dataset.value === selectedValue);
      if (!selectedOption) return;

      options.forEach((option) => {
        option.setAttribute('aria-selected', option === selectedOption ? 'true' : 'false');
      });

      const button = customSelect.querySelector('.custom-select__btn');
      const listbox = customSelect.querySelector('.custom-select__listbox');
      if (button?.firstElementChild && selectedOption.firstElementChild) {
        button.firstElementChild.textContent = selectedOption.firstElementChild.textContent;
      }
      if (listbox) listbox.setAttribute('aria-activedescendant', selectedOption.id);

      customSelect.selectedOption = selectedOption;
    }
  }

  if (!customElements.get('product-sticky-atc')) {
    customElements.define('product-sticky-atc', ProductStickyAtc);
  }
})();
